/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
import {
  bus
} from '../../main';
const $ = window.jQuery = require('jquery');  
import axios from 'axios';
import toast from '../../services/toast';
export default {
  name: 'data-well',
  components: {
  },
  props: [],
  data () {
    return {
      taskList:{},
      taskListResult: [],
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      userDetails:'',
      checkDataTaskModal:false,
      taskDeleteId:'',
      user_is_superuser:false
    }
  },
  computed: {
    ...mapGetters([
      'dataWellStateGetters',
      'acUserDetailsStateGetters'
    ]),
    getTaskList() {
      return this.taskList = this.$store.getters.dataWellStateGetters.data
    },
    getUserDetails() {
      return this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
    },
    SetIntialStatus() {
      if (this.taskList != undefined) {
        this.nextStep = this.taskList.next
        this.taskListResult = this.taskList.results
      }
      if(this.userDetails != undefined){
        this.user_is_superuser = this.userDetails.is_superuser
      }
    },
  },
  mounted () {
    this.getTaskList
    this.SetIntialStatus
    this.getUserDetails
    setInterval(function(){
      location.reload();
    },3000000);
  },
  methods: {
    getTaskListAgain() {
      this.$store.dispatch('getDataWellFun').then((res) => {
        this.taskList = this.$store.getters.dataWellStateGetters.data
      }).catch((err) => {
      })
    },
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.taskList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.taskListResult.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    showDataTaskModalFun(id){
      $("body").addClass("task_modal_actv");
      this.checkDataTaskModal = true
      this.taskDeleteId = id
    },
    removeDataTaskFun(){
      this.$store.dispatch('deleteDataTaskFun', {
        id: this.taskDeleteId,
      })
      .then((res) => {
        if (res.data.code == '2000') {      
          toast.success(res.data.msg); 
          this.getTaskListAgain()
          $("body").removeClass("task_modal_actv");
          this.checkDataTaskModal = false
          this.taskDeleteId = ''
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    hideDataTaskModalFun(){
      $("body").removeClass("task_modal_actv");
      this.checkDataTaskModal = false
      this.taskDeleteId = ''
    }
  },
  watch:{
    getTaskList() {
      return this.$store.getters.dataWellStateGetters.data
    },
    SetIntialStatus() {
      if (this.taskList != undefined) {
        this.taskListResult = this.taskList.results
      }
      if(this.userDetails != undefined){
        this.user_is_superuser = this.userDetails.is_superuser
      }
    },
    getUserDetails() {
      return this.$store.getters.acUserDetailsStateGetters.data
    },
  },
  beforeCreate: function() {
    $('body').addClass('sidebar_collapsed')
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("task_modal_actv");
    $('body').removeClass('sidebar_collapsed')
    next();
  },
}